import Button from './Button';
import Layout from './Layout';

export {
	Button as ButtonTab,
	Layout as ButtonTabLayout,
}